import { StyleSheet } from 'aphrodite';
import { hexToRgbA, typography } from 'util/styleUtil';

const getSkin = (theme) => {
    const globalProfiles = theme.get('globalProfiles');
	const skin = globalProfiles.get('palette');
	const myTypography = typography(theme);

    return StyleSheet.create({
		recContainer: {
			// borderBottom: `1px solid ${skin.get('grayColor5')}`
		},
		recContent: {
			...myTypography.body2,
			color: skin.get('grayColor1')
		}
	});
}

export default getSkin;